module.exports = __webpack_public_path__ + "static/media/release_06@2x.e3027f38.png";